var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutlinedBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24919 1.13877C2.42821 1.13877 0.952006 2.61497 0.952006 4.43596V22.0691C0.952006 23.8901 2.4282 25.3663 4.24919 25.3663H22.0693C23.8903 25.3663 25.3665 23.8901 25.3665 22.0691V4.43596C25.3665 2.61497 23.8903 1.13877 22.0693 1.13877H4.24919Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC",
    strokeWidth: 0.732708
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.452 6.27736L15.5338 10.4022L19.5406 10.7992C19.636 10.8071 19.7271 10.8422 19.8032 10.9003C19.8793 10.9584 19.9371 11.0371 19.9698 11.1271C20.0025 11.217 20.0088 11.3145 19.9879 11.4079C19.967 11.5013 19.9197 11.5867 19.8517 11.6541L16.5542 14.9227L17.7768 19.3643C17.8018 19.4585 17.799 19.5579 17.7689 19.6506C17.7387 19.7433 17.6825 19.8253 17.6068 19.8868C17.5312 19.9482 17.4394 19.9865 17.3425 19.997C17.2456 20.0076 17.1477 19.9899 17.0606 19.9461L12.9984 17.9344L8.94186 19.9436C8.85478 19.9874 8.75691 20.0051 8.66002 19.9946C8.56312 19.984 8.47133 19.9457 8.39568 19.8843C8.32004 19.8228 8.26375 19.7408 8.2336 19.6481C8.20345 19.5554 8.20072 19.456 8.22573 19.3618L9.44831 14.9203L6.14829 11.6516C6.0803 11.5843 6.03305 11.4988 6.01212 11.4054C5.99119 11.312 5.99746 11.2145 6.03019 11.1246C6.06293 11.0346 6.12075 10.9559 6.19681 10.8978C6.27287 10.8397 6.36399 10.8046 6.45937 10.7967L10.4662 10.3997L12.5449 6.27736C12.5876 6.19385 12.6526 6.12377 12.7326 6.07483C12.8127 6.0259 12.9046 6 12.9984 6C13.0922 6 13.1842 6.0259 13.2643 6.07483C13.3443 6.12377 13.4093 6.19385 13.452 6.27736V6.27736Z",
    stroke: "#7E898F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlinedBoxed);
export default __webpack_public_path__ + "static/media/StarOutlinedBoxed.14a380df50bfef286e5378b443f42a94.svg";
export { ForwardRef as ReactComponent };